import React from 'react';

import { Text } from '@fly/core';
import { FlySvgSprite } from '@fly/svg';

import styles from './FlyTextLoading.module.less';

interface FlyTextLoadingProps {
  text: string;
  icon?: {
    name: string;
    size?: number;
    className?: string;
  };
  className?: string;
  textSize?: '1' | '2' | '3' | '4' | '5' | '6' | '7' | '8' | '9';
}

export const FlyTextLoading: React.FC<FlyTextLoadingProps> = ({
  text,
  icon,
  className,
  textSize = '3',
}) => {
  return (
    <div className={`${styles.container} ${className || ''}`}>
      <Text as='span' size={textSize} className={styles.text}>
        {text}
        <span className={styles.dot}>.</span>
        <span className={styles.dot}>.</span>
        <span className={styles.dot}>.</span>
      </Text>
      {icon && (
        <FlySvgSprite
          name={icon.name}
          size={icon.size || 20}
          className={icon.className || styles.icon}
        />
      )}
    </div>
  );
};
